import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { TerminalDto } from '../types/dtos';
export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.mutation<void, { id: string; payload: Partial<TerminalDto> }>({
        query: ({ id, payload }) => ({
            url: `${APP_ENDPOINTS.TERMINAL}/${id}`,
            method: 'PATCH',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'terminals-with-join', id: 'GET-JOIN' },
            { type: 'terminal', id: 'GET-ID' },
            { type: 'places-with-join', id: 'GET-JOIN' },
            { type: 'place', id: 'GET-ID' },
        ],
    });
